(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("../../utils/transitions"), require("../../utils/Transition"));
	else if(typeof define === 'function' && define.amd)
		define(["../../utils/transitions", "../../utils/Transition"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("../../utils/transitions"), require("../../utils/Transition")) : factory(root["../../utils/transitions"], root["../../utils/Transition"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__) {
return 